

app.controller('LoginCtrl', function ($scope, uibDateParser, $http, $window, $location, $timeout, Upload, $q) {
    $scope.user = {
        Email: '',
        Password: '',
    };
    

    var allPromise = $q.all([

        $http({
            method: 'GET',
            url: '/service/client.svc/SignOut',
        }).then(function (data) {
        }, function (error) { })
    ]);


    $scope.loadMessage = 'Loading...';

    $scope.after_login = {};

    $scope.submit = function () {

        //encrypt email
        var key = CryptoJS.enc.Utf8.parse('123456789qwertyu'); // Panjang 16 byte untuk AES-128
        var iv = CryptoJS.enc.Utf8.parse('qwerty0987654321'); // Juga 16 byte

        var plaintext = $scope.user.Email;
        var plaintextPW = $scope.user.Password;

        var encrypted = CryptoJS.AES.encrypt(plaintext, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        var encryptedPW = CryptoJS.AES.encrypt(plaintextPW, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        //send request resendOTP
        var data = {
            Email: encrypted.toString(),
            Password : encryptedPW.toString()
        }

        
        $http({
            method: 'POST',
            url: '/service/client.svc/LoginUser',
            data: {
                UserLogin: data,
            },
        }).then(function (data) {
            $scope.working = false;
            $scope.result = data.data.d;
            if ($scope.result.result) {
                if ($scope.result.IsFinished == 1) {
                    $window.location.href = "#/dashboard";
                    $window.location.reload();
                }

                if ($scope.result.Stage) {
                    if ($scope.result.Stage == 1)
                    {
                        $window.location.href = "#/cif/data-pribadi";
                        //$window.location.href = "#/preparation";
                        $window.location.reload();
                    }
                    if ($scope.result.Stage == 2)
                    {
                        $window.location.href = "#/cif/data-pekerjaan";
                        $window.location.reload();
                    }
                    if ($scope.result.Stage == 3) {
                        $window.location.href = "#/cif/data-pendukung";
                        $window.location.reload();
                    }
                    if ($scope.result.Stage == 4)
                    {
                        if ($scope.result.IsFinished == 1) {
                            $window.location.href = "#/dashboard";
                            $window.location.reload();
                        } else {
                            $window.location.href = "#/cif/data-pernyataan";
                        }
                            
                        if ($scope.result.IsRevised == 1) {
                            $window.location.href = "#/dashboard";
                            $window.location.reload();
                        }
                    }
                }
            }
            else {
                swal('Login Failed', $scope.result.message, 'error');
            }
        },
        function (error) {

        });
    };


    allPromise.then(function () {

    });


});
